import * as React from "react";

const s = require("./header-logo.scss");

interface Props {

}

function HeaderLogo(props: Props) {
    return (
        <div className={s.headerLogo}>Logo</div>
    );
}

export default HeaderLogo;



// WEBPACK FOOTER //
// ./src/components/Logos/HeaderLogo/index.tsx